<h1>Members</h1>
<div class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">
      Filters <button id='memberListClearAll' type="button" (click)="clearFilters()"
        class="btn btn-default pull-right">Clear all</button>
    </h3>
  </div>
  <div class="panel-body">
    <div class="table-nav-menu">
      <span class="pull-right" *ngIf="exportingExcel">
        <div style="width: 28px; height: 28px;" class="loading-spinner"></div>
      </span>
      <a id='memberListExport' *ngIf="!exportingExcel" class="pull-right" (click)="downloadReportModal()">
        <i style="float: right;" class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
      </a>
      <ch-live-search [items]="locations" [showClass]="1" (change)="locationChanged($event)"
        value="{{ pageParams.locationId }}"></ch-live-search>
      <ch-live-search [items]="jobCategories" [showClass]="1" (change)="jobCategoryChanged($event)"
        value="{{ pageParams.jobCategoryId }}"></ch-live-search>
      <ch-select-picker [items]="selectOptions" (change)="typeChanged($event)" value="{{ pageParams.type }}">
      </ch-select-picker>

      <ch-search-input (search)="search($event)" value="{{ pageParams.search }}"></ch-search-input>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header">
    Members
    <button id='memberListReject' *ngIf="hasSelectedItems" ng-disabled="massActionInProgress" type="button"
      (click)="onActionSelected('reject')" class="btn btn-danger pull-right">Reject</button>
    <button id='memberListRequest' *ngIf="hasSelectedItems" type="button" (click)="onActionSelected('request_new_id')"
      class="btn btn-default pull-right">
      Request New ID
    </button>
    <button id='memberListAccept' *ngIf="hasSelectedItems" ng-disabled="massActionInProgress" type="button"
      (click)="onActionSelected('accept')" class="btn btn-default pull-right">Accept</button>
    <button id='memberListCancelLater' *ngIf="hasSelectedItems" ng-disabled="massActionInProgress" type="button"
      (click)="onActionSelected('cancel_subscription_end_of_period')" class="btn btn-default pull-right">
      Cancel at End of Period
    </button>
    <button id='memberListCancelNow' *ngIf="hasSelectedItems" ng-disabled="massActionInProgress" type="button"
      (click)="onActionSelected('cancel_subscription_now')" class="btn btn-default pull-right">
      Cancel Membership Now
    </button>

    <button id='memberListRemoveVIP' *ngIf="hasSelectedItems" ng-disabled="massActionInProgress" type="button"
      (click)="onActionSelected('remove_vip')" class="btn btn-default pull-right">
      Remove VIP
    </button>
  </div>
  <div class="card-block">
    <div>
      <div class="loading-cont" *ngIf="loading">
        <div class="loading-spinner"></div>
      </div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <div class="table-responsive">
        <table class="table table-hover" *ngIf="!loading && 0 < items.length">
          <thead>
            <tr>
              <th><input type="checkbox" (click)="massSelect($event.target.checked)" /></th>
              <th class="sortable">
                <span class="col-name">Name
                  <ch-sortable [column]="'NAME'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
                </span>
              </th>
              <th class="sortable">
                <span class="col-name">Email
                  <ch-sortable [column]="'EMAIL'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
                </span>
              </th>
              <th class="sortable">
                <span class="col-name">Job Title / Employer
                  <ch-sortable [column]="'JOB_TITLE'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
                </span>
              </th>
              <th class="sortable">
                <span class="col-name">Status
                  <ch-sortable [column]="'STATUS'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
                </span>
              </th>
              <th class="sortable">
                <span class="col-name">Signed Up
                  <ch-sortable [column]="'SIGNED_UP'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
                </span>
              </th>
              <th class="sortable">
                <span class="col-name">Renewal date</span>
              </th>
              <th>
                <span class="col-name">RAF</span>
              </th>
              <th><span class="col-name">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items; let i = index">
              <td><input type="checkbox" [(ngModel)]="item.checked" (click)="check(i, $event.target.checked)" /></td>
              <td>
                <div>{{ item.firstName }} {{ item.lastName }}</div>
              </td>
              <td>
                <div>{{ item.email }}</div>
              </td>
              <td>
                <div>{{ item.jobTitle }}<br>{{ item.employer }}</div>
              </td>
              <td>
                <span *ngIf="isSuccessStatus(item.status)" class="label label-success">{{ getStatusLabel(item.status)
                  }}</span>
                <span *ngIf="isDangerStatus(item.status)" class="label label-danger">{{ getStatusLabel(item.status)
                  }}</span>
                <span *ngIf="isWarningStatus(item.status)" class="label label-warning">{{ getStatusLabel(item.status)
                  }}</span>
                <span *ngIf="isTrialEndedStatus(item.status)" class="label label-info">{{ getStatusLabel(item.status)
                  }}</span>
                <span *ngIf="isNotValidStatus(item.status)" class="label label-default">{{ getStatusLabel(item.status)
                  }}</span>
              </td>
              <td>{{ item.createdAt | dateFormat }}</td>
              <td>{{ item.renewalDate | dateFormat }}</td>
              <td>
                <input type="checkbox" [checked]="item.referralsEnabledFlag" onclick="return false;" />
              </td>
              <td class="col-md-2">
                <a class="btn btn-primary" [routerLink]="['/admin/members/edit']"
                  [queryParams]="{ id: item.id }">Edit</a>
                <button type="button" class="btn btn-primary" (click)="preview(item)"
                  [disabled]="!item.proofResourceId">Preview</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination-dropdown *ngIf="!loading" [totalItems]="totalItems" [pageNumber]="pageParams.pageNumber"
      [pageSize]="pageParams.pageSize" (pageChanged)="onPageChanged($event)"></ch-pagination-dropdown>
  </div>
</div>

<ch-new-id-notification-modal-dialog [show]="showMassNewProofDialog" (close)="onCloseMassNewProof()"
  (submit)="massRequestNewId($event)"></ch-new-id-notification-modal-dialog>

<ch-member-preview-modal-dialog [show]="showPreviewDialog" (actionSelected)="onPreviewActionSelected($event)"
  [data]="previewData" (close)="onClosePreview()"></ch-member-preview-modal-dialog>

<ch-member-export-modal-email-dialog [show]="showExportDialog" (onExport)="onExport($event)"
  (onClose)="onCloseExportDialog()"></ch-member-export-modal-email-dialog>

<ch-member-invalid-plan-modal-dialog [show]="showInvalidPlanDialog"
  (onClose)="onCloseInvalidPlanDialog()"></ch-member-invalid-plan-modal-dialog>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/member-list/member-list.component.html